/*********************
 V2 Selector Only Pass: 
 *********************/
import Pass from "../Pass";
import getIntervention from "../../../interventions/interventionFactory";
import { interventionTypes, wcpmPivot } from "../../../constants";
import { getWordMetadata } from "../../../utils/metadataUtils";
import { LOG_DECISION_CONTEXT } from "../../../config";

export default class V2SelectorOnlyPass extends Pass {
  constructor(PASS_CONFIGS) {
    super();
    this.label = "PASS_V2_ONLY";

    // Instantiate all interventions, since the ranked intervention selector uses it own pool to select from
    Object.values(interventionTypes).forEach((interventionType) => {
      if (!PASS_CONFIGS.disabledInterventionTypes.includes(interventionType)) {
        super.addIntervention(getIntervention(interventionType));
      }
    });
  }

  run(state) {
    super.resetForNextRun(); // Reset class vars (rationaleLog, runStillValid, and selectedIntervention)

    // Identify valid interventions, based on state
    super.qualifyInterventions(state);

    // If we meet the V2 intervention selection criteria (end of phrase, not ERSS, not spanish, and we have intervention weights),
    // then attempt to find valid interventions using the V2 intervention selector. If no valid intervention found, we will move on to "Pass2"
    const { wcpm, phraseMetaData, isValidRunForV2, endOfPhrase } = state;

    if (isValidRunForV2) {
      // This will run V2 intervention selection logic because we meet all conditions
      super.selectValidInterventionByRankedSelector(state);

      let fallbackInterventionType;

      const wordMetadata = getWordMetadata(state.word, state);
      if (wcpm && wordMetadata && wordMetadata.NPHON) {
        if (
          wcpm < wcpmPivot &&
          wordMetadata.NPHON < 6 &&
          this.getValidInterventions().includes(interventionTypes.soundout1)
        ) {
          fallbackInterventionType = interventionTypes.soundout1;
        }

        const highWCPMFallbackInterventionType = endOfPhrase
          ? interventionTypes.soundout2
          : interventionTypes.phonemeGiveWord;

        if (
          wcpm >= wcpmPivot &&
          wordMetadata.NPHON < 7 &&
          this.getValidInterventions().includes(
            highWCPMFallbackInterventionType
          )
        ) {
          fallbackInterventionType = highWCPMFallbackInterventionType;
        }
      }

      if (!fallbackInterventionType) {
        fallbackInterventionType = endOfPhrase
          ? interventionTypes.none
          : interventionTypes.giveword;
      }

      super.setFallbackIntervention(fallbackInterventionType);

      // If this pass didn't select anything, see if we qualify to force comprehension intervention
      if (!this.selectedInterventionType) {
        if (
          phraseMetaData &&
          phraseMetaData.questions &&
          phraseMetaData.questions.length
        ) {
          const logMessage =
            "V2 only pass did not find intervention. Forcing comprehension";
          super.selectIntervention(
            interventionTypes.comprehension,
            "SELECTION_RULE - " + logMessage
          );
        }
      }
    } else {
      LOG_DECISION_CONTEXT &&
        this.rationaleLog.push(
          this.label + " - " + `Not valid V2 selection conditions.`
        );
    }

    // Return the selected intervention
    return super.getRunResults();
  }
}
